import { defineNuxtPlugin } from '#app'
import {EnsureQueryDataOptions} from '@tanstack/vue-query'
import {queryClient} from "~/plugins/vue-query";
import {MS_MINUTE} from "~/constants/time";
import {useUserService} from "~/services/userService";
import {asyncComputed} from "@vueuse/core";
import {getAlwaysAvailableQueryOptions} from "~/helpers/queries";

/**
 * Plugin responsible for ensuring that all query data that should always be available actually is available.
 *
 */
export default defineNuxtPlugin(async (nuxtApp) => {
    const {$msal} = useNuxtApp()
    const {getCurrentUser} = useUserService()
    const currentUser = asyncComputed(async () => await getCurrentUser())

    const ensureQueries = () => {
        if ($msal.getAllAccounts()[0]) {
            getAlwaysAvailableQueryOptions(currentUser).forEach((queryOptions) => {
                return queryClient.ensureQueryData({...queryOptions, revalidateIfStale: true} as EnsureQueryDataOptions)
            })
        }
    }

    nuxtApp.hook('page:finish', () => {
        ensureQueries()
    })

    setInterval(() => {
        if (navigator.onLine) {
            ensureQueries()
        }
    }, MS_MINUTE)
})
